var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashedTopLine({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: "100%",
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.5,
    y: 0.5,
    width: "99.7%",
    height: 20.2121,
    stroke: "white",
    strokeDasharray: "4 4"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjIwIj4KICAgIDxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjIwIiBmaWxsPSIjQzRDNEM0Ii8+CiAgPC9tYXNrPgogIDxnIG1hc2s9InVybCgjbWFzazApIj4KICAgIDxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSI5OS43JSIgaGVpZ2h0PSIyMC4yMTIxIiBzdHJva2U9IndoaXRlIiBzdHJva2UtZGFzaGFycmF5PSI0IDQiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgDashedTopLine as ReactComponent };